import Head from "next/head";
import { useRouter } from "next/router";

export default function SEO({
	title,
	description = title,
}: {
	title?: string;
	description?: string;
}) {
	const { asPath } = useRouter();
	const origin =
		typeof window !== "undefined" && window.location.origin
			? window.location.origin
			: "";

	const URL = `${origin}${asPath}`;
	// console.log(origin);

	const siteName = "TheCopyDev";
	const domain = origin;
	const formattedTitle = title ? `${title} - ${siteName}` : siteName;
	// const description = "renderhelp";
	const keywords = "";
	// url path
	// const url = url && url.path ? url.path : undefined
	// url path to home
	const cononical = URL;
	// const featuredImage = domain + image;

	return (
		<Head>
			<title>{formattedTitle}</title>
			{/* doesnt change */}
			<meta charSet="utf-8" />
			<meta content="IE=edge" httpEquiv="X-UA-Compatible" />
			{/* changes */}
			{description && <meta name="description" content={description} />}
			{keywords && <meta name="keywords" content={keywords} />}
			{/* DC */}
			<meta name="robots" content="follow, index" />
			<meta name="theme-color" content="#ffffff" />
			<meta name="msapplication-TitleColor" content="#ffffff" />
			{/* favicons */}
			{/* <link rel="icon" href="@/favicons/favicon.ico" /> */}
			{/* C */}
			{/* {url && <link rel="canonical" href={cononical} />} */}
			<meta property="og:title" content={formattedTitle} />
			<meta property="og:decription" content={description} />
			{/* <meta property="og:url" content={canonical} /> */}
			{/* {featuredImage && (
				<>
					<meta property="og:image" content={featuredImage} />
					<meta property="og:image:alt" content={description} />
				</>
			)} */}
			{/* twitter */}
		</Head>
	);
}
